/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
'use es6'; // use hubspot.bender to access all dep package assets (not just documents-lib)

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import bender from 'hubspot.bender';
import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import BrandingRecord from '../../records/BrandingRecord';
import Loadable from 'UIComponents/decorators/Loadable';
import PDFKeyControls from './PDFKeyControls';
import PDFPage from './PDFPage';
import PDFControls from './PDFControls';
import PDFLoading from './PDFLoading';
import { connect } from 'react-redux';
import * as PDFActions from '../../actions/PDFActions';
const LoadablePDFError = Loadable({
  loader: () => import(
  /* webpackChunkName: "view-secondary-content" */
  './PDFError')
});

class PDFViewer extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hovered: false,
      progress: null,
      pdf: null,
      error: null,
      PDFJS: null,
      PDFJSError: null
    };

    this.retry = () => {
      window.location.reload();
    };

    this.loadPDFJS = () => {
      return new Promise((resolve, reject) => {
        import(
        /* webpackChunkName: "pdf-js" */
        '../../lib/pdf-js').then(({
          PDFJS
        }) => this.setState({
          PDFJS,
          PDFJSError: null
        }, () => {
          resolve();
        }), error => this.setState({
          PDFJSError: error
        }, () => {
          reject(error);
        }));
      });
    };

    this.loadFile = () => {
      const {
        file
      } = this.props;
      const {
        PDFJS
      } = this.state;
      const documentTask = PDFJS.getDocument({
        url: file,
        cMapUrl: `${bender.staticDomainPrefix}${bender.depPathPrefixes['pdf-js']}/cmaps/`,
        cMapPacked: true
      });

      documentTask.onProgress = ({
        loaded,
        total
      }) => {
        this.setState({
          progress: loaded / total * 100
        });
      };

      documentTask.promise.then(pdf => {
        this.setState({
          pdf,
          error: null,
          progress: null
        });
      }, error => {
        this.setState({
          error
        });
      });
    };

    this.handleMouseEnter = () => {
      this.setState({
        hovered: true
      });
    };

    this.handleMouseLeave = () => {
      this.setState({
        hovered: false
      });
    };

    this.renderProgress = () => {
      const {
        pageIndex,
        imagePlaceholders
      } = this.props;
      const {
        progress
      } = this.state;

      if (progress === null) {
        return /*#__PURE__*/_jsx(PDFLoading, {
          pageIndex: pageIndex,
          imagePlaceholders: imagePlaceholders,
          value: 0
        });
      }

      return /*#__PURE__*/_jsx(PDFLoading, {
        pageIndex: pageIndex,
        imagePlaceholders: imagePlaceholders,
        value: progress
      });
    };

    this.renderPDFKeyControls = () => {
      const {
        pageIndex,
        zoom,
        onPage
      } = this.props;
      const {
        pdf
      } = this.state;
      return /*#__PURE__*/_jsx(PDFKeyControls, {
        onPage: onPage,
        pageIndex: pageIndex,
        totalPages: pdf.numPages,
        children: /*#__PURE__*/_jsx("div", {
          className: "pdf-viewer p-all-5",
          children: /*#__PURE__*/_jsx(PDFPage, {
            pdf: pdf,
            pageIndex: pageIndex,
            zoom: zoom
          })
        })
      });
    };

    this.renderPDFControls = () => {
      const {
        branding,
        pageIndex,
        zoom,
        onPage,
        onZoom
      } = this.props;
      const {
        pdf,
        hovered
      } = this.state;
      return /*#__PURE__*/_jsx("div", {
        className: "justify-center",
        style: {
          position: 'absolute',
          bottom: branding.showSalesAd ? 100 : 40,
          left: 0,
          zIndex: 2,
          width: '100%'
        },
        children: /*#__PURE__*/_jsx(PDFControls, {
          visible: hovered,
          pageIndex: pageIndex,
          totalPages: pdf.numPages,
          zoom: zoom,
          onPage: onPage,
          onZoom: onZoom
        })
      });
    };
  }

  componentDidMount() {
    this.props.onReset();
    this.loadPDFJS().then(() => {
      this.loadFile();
    });
  }

  render() {
    const {
      error,
      pdf,
      PDFJSError
    } = this.state;
    const {
      pageIndex,
      presentationName
    } = this.props;

    if (error !== null || PDFJSError !== null) {
      return /*#__PURE__*/_jsx(LoadablePDFError, {
        onRetry: this.retry,
        isPDFError: !!PDFJSError
      });
    }

    if (pdf === null) {
      return this.renderProgress();
    }

    return /*#__PURE__*/_jsxs("div", {
      "aria-label": I18n.text('a11y.viewSpecificPage', {
        pageNumber: pageIndex + 1,
        documentName: presentationName
      }),
      tabIndex: 0,
      className: "pdf-viewer-container",
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave,
      children: [this.renderPDFKeyControls(), this.renderPDFControls()]
    });
  }

}

PDFViewer.propTypes = {
  branding: PropTypes.instanceOf(BrandingRecord).isRequired,
  file: PropTypes.string.isRequired,
  presentationName: PropTypes.string.isRequired,
  imagePlaceholders: PropTypes.array,
  pageIndex: PropTypes.number.isRequired,
  zoom: PropTypes.number.isRequired,
  onReset: PropTypes.func.isRequired,
  onPage: PropTypes.func.isRequired,
  onZoom: PropTypes.func.isRequired
};
PDFViewer.defaultProps = {
  imagePlaceholders: []
};
export default connect(({
  view: {
    pdf
  }
}) => pdf, {
  onPage: PDFActions.changePage,
  onZoom: PDFActions.changeZoom,
  onReset: PDFActions.reset
})(PDFViewer);